const apiconfig = {
  // TEST endpoint in Ireland: https://gvmho9b9ob.execute-api.eu-west-1.amazonaws.com/test
  // PROD endpoint in Ireland: to be defined
  endpoint: "https://gvmho9b9ob.execute-api.eu-west-1.amazonaws.com/test",
};

export default apiconfig;
